export const initData = {
  clientProfile: [
    {
      clientProfileType: "CPROF7",
      data: {
        whoOpenAccount: 1
      }
    }
  ],
  clientAddress: [
    {
      addressType: "ADRT1",
      data: {}
    }
  ],
  clientPhone: [
    {
      clientPhoneType: "Mob",
      data: {}
    }
  ],
  clientMail: [
    {
      clientEmailType: "MAILL1",
      data: {}
    }
  ],
  documentList: [
    {
      documentList: "PEN1",
      data: {
        orgStructure: "",
        regulatons: "",
        rcList: "",
        finRaport: "",
        ceoDocument: "",
        ceoId: "",
        benefDocuments: "",
        otherDoc: ""
      }
    }
  ],
  clientPlanCashTurn: [
    {
      clientPlanCashTurn: "PEN1",
      data: {
        clientPlanCashTurnover: "PLCASH1"
      }
    }
  ],
  clientPlanTurn: [
    {
      clientPlanTurn: "PEN1",
      data: {}
    }
  ],
  clientFundsRecCountrys: [
    {
      clientFundsRecCountryType: "S.121",
      data: {}
    }
  ],
  clientFundsSentCountry: [
    {
      clientFundsSentCountryType: "CFUSC1",
      data: {}
    }
  ],
  clientCeo: [
    {
      clientCeoType: "CEOC1",
      data: {
        otherCeoCitizien: 0
      }
    }
  ],
  clientBeneficiaries: [
    {
      clientBenefType: "BENEF1",
      data: {}
    }
  ],
  clientBasicBusiness: [
    {
      clientBasicBusinessType: "CBBSN1",
      data: {}
    }
  ],
  clientBusPartner: [
    {
      cientBusPartnerType: "S.121",
      data: {}
    }
  ],
  clientTaxPayerCountrys: [
    {
      clientTaxPayerCountryType: "TAXC1",
      data: {}
    }
  ],
  clientPlanServices: [
    {
      clientPlanServicesType: "PEN1",
      data: {
        clientPlanServicesCard: true,
        clientPlanServicesTransf: false,
        clientPlanServicesCredSb: false,
        clientPlanServicesDep: false,
        clientPlanServicesEb: false,
        bankAccType: "ACCT10"
      }
    }
  ],
  companyFunds: [
    {
      companyFunds: "PEN1",
      data: {
        shareholderCap: false,
        activityProfit: false,
        saleProperty: false,
        incomInvest: false,
        subsidies: false,
        borroving: false,
        other: false
      }
    }
  ],
  clientPoliticsPosition: [
    {
      ClientPoliticsPosList: "PEN1",
      data: {
        clientPoliticsMinist: false,
        clientPoliticsJutge: false,
        clientPoliticsMay: false,
        clientPoliticsAudit: false,
        clientPoliticsMJoint: false,
        clientPoliticsAmb: false,
        clientPoliticsJoint: false,
        clientPoliticsInternOrg: false,
        clientPoliticsPolPart: false,
        clientPoliticArmForces: false,
        clientPoliticOther: false
      }
    }
  ],
  clientRep: [
    {
      clientRepType: "REPC1",
      data: {}
    }
  ],
  mainCustom: [
    {
      mainCustom: "PEN1",
      data: {}
    }
  ],
  PaymOut: [
    {
      PaymOut: "PEN1",
      data: {}
    }
  ],
  planServTurn: [
    {
      planServTurn: "PEN1"
    }
  ]
};
